module.exports = __webpack_public_path__ + "static/media/in-awe.26e19e38.svg";